import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "notification_normal",
  "use": "notification_normal-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol viewBox=\"0 0 12 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"notification_normal\">\n<path d=\"M10.7639 5H6.56758L8.11666 0.94375C8.26211 0.46875 7.84393 0 7.27303 0H2.03673C1.60037 0 1.22946 0.278125 1.17128 0.65L0.00765729 8.15C-0.0614328 8.6 0.345835 9 0.873102 9H5.18942L3.51307 15.0781C3.38216 15.5531 3.80398 16 4.36033 16C4.66579 16 4.95669 15.8625 5.11669 15.625L11.5166 6.125C11.8548 5.62813 11.4366 5 10.7639 5Z\" fill=\"black\" fill-opacity=\"0.3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol